"use client";

import { Dialog, DialogTrigger, DialogContent, DialogHeader } from "@/components/ui/dialog";
import React from "react";
import Image from "next/image";
import { CheckoutSubscribeForm } from "./checkout-subscribe-form";
import ReviewStarsWithExample from "./review-stars-with-example";
import { Avatar } from './avatar';

interface CheckoutSubscribeDialogProps {
    userId: string;
    productId: number;
    title: string;
    profileImageUrl: string | null;
    slug: string;
    hexColour: string;
    name: string | null;
    isPaidProduct: boolean;
    price: number | null;
    stripePriceId: string | null;
    selectedReview: {
        name: string | null;
        title: string | null;
        rating: number | null;
    }
    fetchClientSecret: (email: string, firstName: string, lastName: string, title: string, userId: string, stripePriceId: string) => Promise<any>;
    isOpen: boolean;
    onClose: () => void;
    onOpenChange: (isOpen: boolean) => void;
    onSuccessfulSubscription: () => void;
}

export function CheckoutSubscribeDialog({ userId, productId, title, hexColour, profileImageUrl, slug, name, isPaidProduct, price, stripePriceId, fetchClientSecret, isOpen, onClose, onOpenChange, onSuccessfulSubscription, selectedReview}: CheckoutSubscribeDialogProps) {
    const dialogRef = React.useRef<HTMLButtonElement | null>(null);

    return (
        <div className="fixed top-4 right-4 z-50">
          <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogTrigger ref={dialogRef}>
            </DialogTrigger>
            <DialogContent className="h-full sm:h-auto">
                <DialogHeader className="flex items-center justify-center text-center space-y-4 mx-4">
                    <div className="flex flex-col space-y-1 items-center justify-center text-center">
                        <div className="relative bg-white rounded-full border-2 border-white shadow-xl overflow-hidden w-20 h-20">
                            {profileImageUrl ? (
                                <Image 
                                    src={profileImageUrl} 
                                    alt={`${name}'s profile image`} 
                                    width={128} 
                                    height={128} 
                                    className="absolute inset-0 w-full h-full object-cover" 
                                />
                            ) : (
                                <Avatar name={name || ''} size="md" className="w-full h-full" colorise />
                            )}
                        </div>
                        <span className="text-2xl text-zinc-800 font-bold">{title}</span>
                        { price && (
                            <span className="text-md text-zinc-800">{`£${(price / 100).toFixed(2)}`}</span>
                        )}
                    </div>
                    { selectedReview.rating && (
                            <ReviewStarsWithExample hexColour={hexColour} rating={selectedReview.rating} title={selectedReview.title} name={selectedReview.name} /> 
                    )}
                </DialogHeader>
                <CheckoutSubscribeForm fetchClientSecret={fetchClientSecret} productId={productId} title={title} stripePriceId={stripePriceId} hexColour={hexColour} userId={userId} setOpen={onOpenChange} name={name} slug={slug} onSuccessfulSubmission={onSuccessfulSubscription} />
            </DialogContent>
          </Dialog>
        </div>
    );
}